import { Singleton } from 'annotation';
import environment from 'environment';

import ProxyService from './Proxy';

import EntityAware from '../entity/EntityAware';
import Pendaftar from "../entity/Pendaftar";
import Parameter from "./Parameter";
import ProsesPendaftar from "../entity/ProsesPendaftar";
import PindahPendidikan from "../entity/PindahPendidikan";

@Singleton
export default class PendaftarService extends ProxyService {

    public api: string = environment.PENDAFTAR_API;   // define api url to fetch data

    public apiPersyaratan: string = environment.PERSYARATAN_API;   // define api url to fetch data

    public apiMobile: string = environment.MOBILE_API

    public serializer: EntityAware = Pendaftar;

    public serializerProses: EntityAware = ProsesPendaftar;

    public serializerPindah: EntityAware = PindahPendidikan;

    public doPindahPendidikan(param: any): Promise<any> {
        const api: string = this.api + `/pindah`;
        return this.request(new Parameter(param).setMethod(Parameter.methods.POST)
            .serializeData(this.serializerPindah).setUrl(api));
    }

    public findDaftarBiaya(param: any): Promise<any> {
        const parameter = new Parameter().setUrl(`${this.api}/biaya/daftar`, param);

        return this.request(parameter);
    }

    public findProsesPendaftar(nomor: string): Promise<any> {
        const api: string = this.api + `/proses?nomor=${nomor}`;
        const parameter = new Parameter().setUrl(api).serializeData(this.serializerProses);

        return this.request(parameter);
    }

    public downloadKwitansi(nomor: string, nama: string) {
        let api: string = this.apiMobile + `/${nomor}`;
        return super.downloadFile(api, `${nomor}_KWITANSI_${nama}`, false);
    }

    public downloadProsesPersyaratan(nomor: string, nama: string) {
        let api: string = this.api + `/download/persyaratan?nomor=${nomor}`;
        return super.downloadFile(api, `${nomor}_PERSYARATAN_${nama}`, false);
    }

    public downloadProsesSeragam(nomor: string, nama: string) {
        let api: string = this.api + `/download/seragam?nomor=${nomor}`;
        return super.downloadFile(api, `${nomor}_SERAGAM_${nama}`, false);
    }

    public generatePublicURL(url: string): Promise<any> {
        let api: string = this.apiPersyaratan + `/dokumen/view?url=${url}`;
        const parameter = new Parameter().setUrl(api)
        return this.request(parameter);
    }

    public downloadPernyataan(nomor: string, nama: string) {
        let api: string = this.api + `/download/pernyataan?nomor=${nomor}`;
        return super.downloadFile(api, `${nomor}_PERJANJIAN_${nama}`, false);
    }

    public downloadImagePersyaratan(nomor: string, namaLengkap: string, docs: string) {
        let api: string = this.api + `/persyaratan/download?nomor=${nomor}&docs=${docs}`;
        return super.downloadFile(api, `${namaLengkap}_${nomor}_${docs}`, false);
    }
}
